import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../../common/Header/Header";
import {
  ScheduleServicesModal,
  MapModal,
  CancelServiceModal,
  CreateAVModal,
  MessageAVModal,
  MessageLocksmithModal,
  MessageTowModal,
  BatterySaleModal,
} from "../../common/Modals/Modals";
import {
  ClientDetail,
  AvailableServices,
  SelectedServices,
  HandleCaseButtons,
  AllyDetail,
} from "./IncidenceSections";
import { caseService } from "../../../services/caseService";
import { vehicleService } from "../../../services/vehicleService";
import { batteryService } from "../../../services/batteryService.js";
import { stagesService } from "../../../services/stagesService";
import { buildCreateTowPayload } from "../../../assets/helpers/towService";
import { buildLocksmithProvidersParams } from "../../../assets/helpers/locksmithProviders";
import { notify } from "../../../assets/helpers/toast";
import {
  afiliatedServices,
  particularServices,
  enumStatus,
  authorizedByOptions,
  paymentMethods as metodosDePago,
  addressEnum,
  caseType,
  resolveCancelReasonType,
} from "../../../assets/helpers/options";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useIvaCalculation from "../../../hooks/useIvaCalculation";
import * as schemas from "../../../assets/schemas/schemas";
import { IncidenceDetailForm } from "../Incidence/IncidenceSections";
import {
  applyCasePhoneFields,
  formatPhoneForInput,
} from "../../../assets/helpers/phoneHelpers";
import { membershipService } from "../../../services/membershipService";
import { rateService } from "../../../services/rateService";
import { providersService } from "../../../services/providersService";
import { garageService } from "../../../services/garageService";
import { faultsService } from "../../../services/faultsService";
import { membershipProductsService } from "../../../services/membershipProductsService";
import { productService } from "../../../services/productService";
import { servicesService } from "../../../services/servicesService";
import { statesService } from "../../../services/statesService";
import { CraneCounter } from "../../miscelaneos/CraneCounter/CraneCounter.jsx";
import {
  capitalize,
  filterParams,
  exists,
  getOption,
  filterOption,
  filterOptionById,
  parseNull,
  isValidMongoId,
  addressToGeoCode,
  validatePaymentRefLenght,
  isLocksmithService,
} from "../../../assets/helpers/funciones";
import {
  createLocksmithService,
  setLocksmithPaymentDefaults,
} from "../../../assets/helpers/locksmithPayment";
import { useHistory } from "react-router-dom";
import {
  PaymentStatusOptions,
  PaymentStatus,
  referenceLocation,
  clientTypes
} from "../../../assets/helpers/options";
import moment from "moment";

import "./IncidenceDetail.scss";
import { cashReceiverService } from "../../../services/cashReceiverService.js";

export const EditCase = () => {
  const [statesOptions, setStatesOptions] = useState([]);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [originCitiesOptions, setOriginCitiesOptions] = useState([]);
  const [destinycitiesOptions, setDestinyCitiesOptions] = useState([]);
  const [faultsOptions, setFaultsOptions] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [filteredMethods, setFilteredMethods] = useState([]);
  const [errorsDropzone, setErrorsDropzone] = useState({});
  const [cashBackImage, setCashBackImage] = useState([]);
  const [cashReceiverOptions, setCashReceiverOptions] = useState([]);
  const [showSchedule, setShowSchedule] = useState({
    battery: false,
    show: false,
  });
  const [fileUploaded, setFileUploaded] = useState([]);
  const [openPayModal, setOpenPayModal] = useState(false);
  const [providersOptions, setProvidersOptions] = useState([]);
  const [recommendedProvidersOptions, setRecommendedProvidersOptions] =
    useState([]);
  const prevWithOutDestinyRef = useRef(false);
  const recommendedProvidersRequestRef = useRef(0);
  const [selectedBike, setSelectedBike] = useState("");
  const [caseInfo, setCaseInfo] = useState();
  const [dollarRate, setDollarRate] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [showErrorAPI, setShowErrorAPI] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [bsDisabled, setbsDisabled] = useState(true);
  const [craneCounter, setCraneCounter] = useState([]);
  const [addressOption, setAddressOption] = useState([]);
  const [reason, setReason] = useState("");
  const [showCraneCounterModal, setShowCraneCounterModal] = useState({
    show: false,
    src: "",
    zoom: 1,
  });
  const [availableServices, setAvailableServices] = useState({
    selected: "",
    available: [],
  });
  // Cerrajeria se presta con un proveedor recomendado en lugar de un motorizado
  const selectableProviders =
    availableServices?.selected?.code === afiliatedServices?.LOCKSMITH
      ? recommendedProvidersOptions
      : providersOptions;
  const chatRacePreloadDone = useRef(false);
  const [showSMSTowModal, setShowSMSTowModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [batterySaleModal, setBatterySaleModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [batteryOptions, setBatteryOptions] = useState([]);
  const [showSMSModal, setShowSMSModal] = useState({
    isOpen: false,
    provider: "",
  });
  const [showCancelService, setShowCancelService] = useState({
    show: false,
    caseSelected: "",
    cancelOptions: [],
  });

  const openSMSModal = () => {
    getDollarRate();
    let [provider] = selectableProviders.filter((p) => p?._id === selectedBike);
    setShowSMSModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSModal?.isOpen,
        provider: provider,
      };
    });
  };

  const getCashReceivers = () => {
    cashReceiverService
      .getCashReceivers()
      .then((response) => {
        if (response.status === 200) {
          setCashReceiverOptions(response?.data?.cashReceivers);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((e) => {
        console.log("Error trayendo las cajas de efectivo", e);
      });
  };

  const getDollarRate = () => {
    rateService
      .getDollarRate()
      .then((response) => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
          setbsDisabled(true);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const [clientSearch, setClientSearch] = useState({
    searchParam: "",
    options: [],
    isOpen: false,
    selected: "",
    exists: true,
  });

  const originRef = useRef();
  const destinyRef = useRef();
  const isMountedRef = useRef(true);
  const { t } = useTranslation();

  const history = useHistory();

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setValue: setValue2,
    getValues: getValues2,
    resetField: resetField2,
    watch: watch2,
    control: control2,
  } = useForm({
    resolver: yupResolver(schemas.CreateIncidenceSchema(t)),
  });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    formState: { errors: errors3 },
    setValue: setValue3,
    getValues: getValues3,
    resetField: resetField3,
    watch: watch3,
    setError: setError3,
  } = useForm({
    resolver: yupResolver(schemas.CreateAVFormSchema(t)),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    formState: { errors: errors4 },
    setValue: setValue4,
    control: control4,
  } = useForm({
    resolver: yupResolver(schemas.ScheduleServiceSchema(t)),
  });

  const {
    register: register6,
    handleSubmit: handleSubmit6,
    setValue: setValue6,
    watch: watch6,
    formState: { errors: errors6 },
  } = useForm({
    resolver: yupResolver(schemas.createFollowUpSchema(t)),
  });

  const [_case, setCase] = useState("");
  const [_caseForm, setCaseForm] = useState("");
  let { caseId } = useParams();
  const [origin, setOrigin] = useState({
    lat: "",
    lng: "",
    address: "",
  });
  const [destiny, setDestiny] = useState({
    lat: "",
    lng: "",
    address: "",
  });

  const [route, setRoute] = useState({
    distance: "",
    time: "",
  });

  const editParticularCase = handleSubmit2(async (data) => {
    let dataToPost = applyCasePhoneFields({ ...data });
    dataToPost.originLatitude = origin?.lat.toString();
    dataToPost.originLongitude = origin?.lng.toString();
    dataToPost.destinyLatitude = destiny?.lat.toString();
    dataToPost.destinyLongitude = destiny?.lng.toString();

    if (isValidMongoId(dataToPost?.originLocationStatus)) {
      dataToPost.originLocationId = watch2("originLocationStatus");
      dataToPost.originLocationStatus = addressEnum?.GARAGE;
    }

    if (isValidMongoId(dataToPost?.destinyLocationStatus)) {
      dataToPost.destinyLocationId = watch2("destinyLocationStatus");
      dataToPost.destinyLocationStatus = addressEnum?.GARAGE;
    }

    if (data?.withOutDestinyAddress) {
      const latLng = await addressToGeoCode(originRef.current.value);
      dataToPost.originLatitude = latLng?.lat.toString();
      dataToPost.originLongitude = latLng?.lng.toString();

      setValue2("originAddress", originRef.current.value);
      dataToPost.originAddress = originRef.current.value;
    }

    if (!validateAddresses(dataToPost)) {
      return null;
    }

    if (_case?.businessAlly) {
      dataToPost.businessAlly = _case?.businessAlly?._id;
    }

    // Datos utilizados unicamente para manejar logica del form
    delete dataToPost?.isOriginBasement;
    delete dataToPost?.withOutDestinyAddress;
    // Unicamente para casos particulares
    dataToPost.particularCustomer = _case?.particularCustomer?._id;
    if (!isLoading) {
      setIsloading(true);
      caseService
        .editCase(filterParams(dataToPost), _case?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Caso editado con exito`, "success");
            setCase((prevState) => {
              return {
                ...prevState,
                selected: response?.data?.case,
              };
            });
            setIsloading(false);
            getServices(response?.data?.case);
            // history.push('/services');
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const resolveId = (value) => value?._id || value || "";

  const getAvailableProducts = (_case) => {
    const params = {
      membershipId: resolveId(_case?.membership),
      originCityId: resolveId(_case?.originCity),
      distance: parseFloat(_case?.caseKm),
      caseId: watch2("thirdPartyService") ? _case?._id : "",
    };

    membershipProductsService
      .getAvailableProducts(filterParams(params))
      .then((response) => {
        if (response.status === 200) {
          let availableServices = response?.data?.availableServices;
          if (watch2("withOutDestinyAddress")) {
            availableServices = availableServices.filter(
              (a) =>
                ![particularServices.crane, afiliatedServices.crane].includes(
                  a?.code
                )
            );
          }
          setAvailableServices((prevState) => {
            return {
              ...prevState,
              selected: "",
              available: [...availableServices],
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getAvailablePAPProducts = (caseid) => {
    membershipProductsService
      .getAvailablePAPProducts(caseid)
      .then((response) => {
        if (response.status === 200) {
          let availableServices = response?.data?.products;
          if (watch2("withOutDestinyAddress")) {
            availableServices = availableServices.filter(
              (a) =>
                ![particularServices.crane, afiliatedServices.crane].includes(
                  a?.code
                )
            );
          }
          setAvailableServices((prevState) => {
            return {
              ...prevState,
              selected: "",
              available: [...availableServices],
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getServices = (_case) => {
    productService
      .getAvailableProducts(resolveId(_case?.originCity), "particular")
      .then((response) => {
        if (response.status === 200) {
          let availableServices = response?.data?.availableServices;
          if (watch2("withOutDestinyAddress")) {
            availableServices = availableServices.filter(
              (a) =>
                ![particularServices.crane, afiliatedServices.crane].includes(
                  a?.code
                )
            );
          }
          setAvailableServices((prevState) => {
            return {
              ...prevState,
              selected: "",
              available: [...availableServices],
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getCaseDetail = (caseId) => {
    caseService
      .getCaseById(_case?._id)
      .then((response) => {
        if (response.status === 200) {
          setCaseInfo(response?.data?.case);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const selectService = (service) => {
    // Cerrajeria no requiere direccion destino y la presta un proveedor recomendado
    if (
      service?.code === afiliatedServices?.LOCKSMITH &&
      availableServices?.selected?.code !== afiliatedServices?.LOCKSMITH
    ) {
      prevWithOutDestinyRef.current = watch2("withOutDestinyAddress");
      setValue2("withOutDestinyAddress", true);
      // La lista se consulta en el efecto que observa el servicio y la ubicacion
      if (!getValues2("originState") || !getValues2("originCity")) {
        notify("Debe seleccionar el estado y la ciudad de origen", "info");
      }
    } else if (
      service?.code !== afiliatedServices?.LOCKSMITH &&
      availableServices?.selected?.code === afiliatedServices?.LOCKSMITH
    ) {
      setValue2("withOutDestinyAddress", prevWithOutDestinyRef.current);
    }

    getCaseDetail();
    let services = availableServices?.available;
    setSelectedBike("");
    services.forEach((e) => {
      e.selected = false;
      if (e._id === service._id) {
        e.selected = true;
      }

      setAvailableServices((prevState) => {
        return {
          ...prevState,
          selected: service,
          available: [...services],
        };
      });
    });
  };

  const clearThirdPartyData = () => {
    resetField2("thirdPartyParticularCustomerName");
    resetField2("thirdPartyParticularCustomerLastName");
    resetField2("thirdPartyServicePhonePrefix");
    resetField2("thirdPartyServicePhoneNumber");
    resetField2("thirdPartyVehicleBrand");
    resetField2("thirdPartyVehicleModel");
    resetField2("thirdPartyVehicleColor");
    resetField2("thirdPartyVehicleYear");
    resetField2("thirdPartyVehiclePlate");
  };

  const getVehicleBrands = () => {
    vehicleService
      .getVehicleBrands()
      .then((response) => {
        if (response.status === 200) {
          setBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const updateLocationStatus = (reference) => {
    setValue2(`${reference}LocationStatus`, addressEnum?.OTHER);
    setValue2("caseKm", "");
  };

  const handleModelOptsions = (brand) => {
    vehicleService
      .getVehicleModels(brand)
      .then((response) => {
        if (response.status === 200) {
          setModelOptions(response?.data?.models);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const validateAddresses = (data) => {
    if (!data?.withOutDestinyAddress && !data?.destinyAddress) {
      notify("Debe seleccionar una dirección de destino", "error");
      return false;
    }
    if (!data?.originAddress) {
      notify("Debe seleccionar una dirección de origen", "error");
      return false;
    } else return true;
  };

  const editAffiliatedCase = handleSubmit2(async (data) => {
    let dataToPost = applyCasePhoneFields({ ...data });

    dataToPost.originLatitude = origin?.lat.toString();
    dataToPost.originLongitude = origin?.lng.toString();
    dataToPost.destinyLatitude = destiny?.lat.toString();
    dataToPost.destinyLongitude = destiny?.lng.toString();

    if (isValidMongoId(dataToPost?.originLocationStatus)) {
      dataToPost.originLocationId = watch2("originLocationStatus");
      dataToPost.originLocationStatus = addressEnum?.GARAGE;
    }
    // dataToPost.isTripService = data?.segViaje;
    delete dataToPost.segViaje;

    if (isValidMongoId(dataToPost?.destinyLocationStatus)) {
      dataToPost.destinyLocationId = watch2("destinyLocationStatus");
      dataToPost.destinyLocationStatus = addressEnum?.GARAGE;
    }

    dataToPost.destinyLatitude = destiny?.lat.toString();
    dataToPost.destinyLongitude = destiny?.lng.toString();

    if (data?.withOutDestinyAddress) {
      const latLng = await addressToGeoCode(originRef.current.value);
      dataToPost.originLatitude = latLng?.lat.toString();
      dataToPost.originLongitude = latLng?.lng.toString();

      setValue2("originAddress", originRef.current.value);
      dataToPost.originAddress = originRef.current.value;
    }

    if (!validateAddresses(dataToPost)) {
      return null;
    }

    const membershipId =
      clientSearch?.selected?._id ||
      resolveId(_case?.membership);

    if (_case?.papMembership) {
      dataToPost.papMembership = resolveId(_case?.papMembership);
      dataToPost.vehicleData = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        brand: data?.vehicleBrand,
        model: data?.vehicleModel,
        color: data?.vehicleColor,
        plate: data?.vehiclePlate,
        year: data?.vehicleYear,
        phonePrefix: dataToPost?.phonePrefix,
        phoneNumber: dataToPost?.phoneNumber,
      };
      delete dataToPost?.membership;
      delete dataToPost?.businessAlly;
    } else {
      dataToPost.membership = membershipId;
    }

    // Datos utilizados unicamente para manejar logica del form
    delete dataToPost?.isOriginBasement;
    delete dataToPost?.withOutDestinyAddress;

    delete dataToPost?.firstName;
    delete dataToPost?.lastName;
    delete dataToPost?.vehicleBrand;
    delete dataToPost?.vehicleModel;
    delete dataToPost?.vehicleColor;
    delete dataToPost?.vehiclePlate;
    delete dataToPost?.vehicleYear;
    delete dataToPost?.phonePrefix;
    delete dataToPost?.phoneNumber;

    if (!isLoading) {
      setIsloading(true);
      caseService
        .editCase(filterParams(dataToPost), _case?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Caso editado con exito`, "success");
            setCase((prevState) => {
              return {
                ...prevState,
                selected: response?.data?.case,
              };
            });
            setIsloading(false);
            if (_case?.papMembership) {
              getAvailablePAPProducts(response?.data?.case?._id);
            } else {
              getAvailableProducts(response?.data?.case);
            }
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const changePaymentStatus = () => {
    setValue3("authorizedBy", "");

    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      return;
    }

    if (watch3("paymentStatus") === PaymentStatus?.COURTESY) {
      setValue3("pvp", 0);
      return null;
    }
    if (watch3("paymentStatus") === PaymentStatus?.N_A) {
      setValue3("pvp", 0);
    } else {
      setValue3("pvp", "");
    }
  };

  const restorePaymentMethods = () => {
    if (parseFloat(watch3("pvp")) === 0) {
      for (let i = 0; i < parseInt(watch3("paymentMethods")); i++) {
        resetField3(`method${i}`);
        resetField3(`reference${i}`);
        resetField3(`paymentMethod${i}`);
        resetField3(`amount${i}`);
        resetField3(`amountBsS${i}`);
      }
      resetField3("paymentMethods");
    }
    // setValue3()
  };

  const validateMaxPaymentMethods = () => {
    if (watch3("paymentMethods") > 5) {
      setValue3("paymentMethods", 5);
      notify("El limite permitido es de 5 métodos de pago", "info");
    }
  };

  const refreshAfterCancel = () => {
    history.push("/services");
  };

  const appendFile = (data) => {
    const formData = new FormData();
    formData.append("case", data?.case);
    formData.append("product", data?.product);
    formData.append("provider", data?.provider);
    formData.append("price", data?.price ?? 0);
    formData.append("pvp", data?.pvp);
    formData.append("paymentStatus", data?.paymentStatus);
    if (data?.authorizedBy) {
      formData.append("authorizedBy", data?.authorizedBy);
    }

    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      formData.append("battery", watch6("battery"));
    }
    // SI es cuentas por cobrar o NA no anexar datos ni comprobantes de pago

    if (
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      for (var i = 0; i < data?.payments.length; i++) {
        formData.append(`payments[${i}][amount]`, data?.payments[i].amount);
        formData.append(
          `payments[${i}][amountBsS]`,
          data?.payments[i].amountBsS
        );
        formData.append(`payments[${i}][method]`, data?.payments[i].method);
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i].reference
        );
        if (data?.payments[i].accHolder) {
          formData.append(
            `payments[${i}][accHolder]`,
            data?.payments[i].accHolder
          );
        }
        if (
          [
            metodosDePago?.CASH_USD,
            metodosDePago?.CASH_BS,
            metodosDePago?.CASH_EUR,
          ].includes(
            filterOptionById(paymentMethods, data?.payments[i]?.method)?.name
          )
        ) {
          formData.append(
            `payments[${i}][cashReceiver]`,
            data?.payments[i]?.cashReceiver
          );
        }

        if (data.addIva) {
          formData.append(`payments[${i}][ivaPercentage]`, data?.ivaPercentage);
          formData.append(`payments[${i}][ivaAmount]`, data.ivaAmount);
        }

        if (showErrorAPI && watch3(`skipApiValidationError${i}`)) {
          formData.append(
            `payments[${i}][skipApiValidationError]`,
            watch3(`skipApiValidationError${i}`)
          );
        }
      }

      for (let i = 0; i < parseInt(watch3("paymentMethods")); i++) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }
    }

    // Load as many files as payment methods we have
    if (
      fileUploaded.length !== parseFloat(watch3("paymentMethods")) &&
      parseFloat(watch3("paymentMethods")) > 0 &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      notify("Ingrese comprobantes de pago", "info");
      return null;
    }
    if (
      parseFloat(watch3("pvp")) &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      let totalSum = 0;
      for (let i = 0; i < data?.payments.length; i++) {
        totalSum = totalSum + parseFloat(data?.payments[i].amount);
      }
      const pvpMoreIvaAmount = parseNull(watch3("pvp")) + parseNull(watch3("ivaAmount"));
      if (totalSum !== pvpMoreIvaAmount) {
        notify(
          "Monto a pagar por el cliente y suma de los pagos no coinciden",
          "info"
        );
        return null;
      }
    }

    for (let j = 0; j < parseFloat(watch3("cashbackMethodsQuantity")); j++) {
      formData.append(`paymentChanges[${j}][paid]`, data[`paid`]);
      formData.append(
        `paymentChanges[${j}][method]`,
        data[`returnedMethod${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amount]`,
        data[`returnedAmount${j + 1}`]
      );
      formData.append(
        `paymentChanges[${j}][amountBsS]`,
        data[`returnedAmountBsS${j + 1}`]
      );
      if (data[`returnedReference${j + 1}`]) {
        formData.append(
          `paymentChanges[${j}][ref]`,
          data[`returnedReference${j + 1}`]
        );
      }
      formData.append(
        `paymentChanges[${j}][hasEvidence]`,
        data[`returnedReference${j + 1}`] ? true : false
      );
      if (cashBackImage[`image${j + 1}`]) {
        formData.append(
          `paymentChangeEvidence`,
          cashBackImage[`image${j + 1}`]
        );
      }
    }

    return formData;
  };

  const validateTotalPayment = (data) => {
    if (
      (parseFloat(watch3("pvp")) >= 0 ||
        parseFloat(watch3("amountHandling")) >= 0 ||
        parseFloat(watch3("amountExcess")) >= 0) &&
      ![PaymentStatus?.N_A, PaymentStatus?.CUENTA_POR_COBRAR]?.includes(
        watch3("paymentStatus")
      )
    ) {
      let totalSum = 0;
      for (let i = 0; i < watch3("paymentMethods"); i++) {
        totalSum = totalSum + parseFloat(watch3(`amount${i}`));
      }
      if (
        totalSum !==
        parseNull(watch3("pvp")) +
        parseNull(watch3("amountHandling")) +
        parseNull(watch3("amountExcess")) +
        parseNull(watch3("ivaAmount"))
      ) {
        notify(
          "Monto a pagar por el cliente y la suma de los pagos no coinciden",
          "info"
        );
        return false;
      } else return true;
    } else return true;
  };

  const createAVService = handleSubmit3(async (data) => {
    if (isLocksmithService(availableServices?.selected)) {
      if (isLoading) return;
      setIsloading(true);
      createLocksmithService({
        caseId: _case?._id,
        provider: selectedBike,
        data,
      })
        .then(({ created, saved, response }) => {
          if (!created) {
            notify(
              `${response?.data?.message || response?.message || "No pudimos crear el servicio de cerrajería"}`,
              "error"
            );
            setIsloading(false);
            return;
          }
          notify(
            saved
              ? `Servicio de cerrajería creado con exito`
              : `El servicio se creó, pero no se pudo guardar el costo o la factura de cerrajería`,
            saved ? "success" : "error"
          );
          history.push("/services");
          setIsloading(false);
        })
        .catch(() => setIsloading(false));
      return;
    }

    if (!validatePaymentRefLenght(data, setError3, paymentMethods)) {
      return;
    }

    let isCash =
      watch3("method0") ===
      filterOption(paymentMethods, metodosDePago?.CASH_USD)?._id;

    // Valida que la suma de los pagos sea igual al total a pagar
    if (!validateTotalPayment(data)) {
      return null;
    }

    if (isCash) {
      calculateCashBack();

      if (parseFloat(watch3("cashbackMethodsQuantity")) > 0) {
        // Validate the total of the cashback
        // Validate that all images are up
        if (!validateCashBackTotal() || !validateCashBackImages()) {
          return null;
        }
      }
    }

    let dataToPost = { ...data };
    dataToPost = loadPaymentForms(dataToPost);
    delete dataToPost?.contact;
    delete dataToPost?.vehicleBrand;
    delete dataToPost?.vehicleColor;
    delete dataToPost?.vehicleYear;
    delete dataToPost?.vehicleModel;
    delete dataToPost?.estimatedTime;
    delete dataToPost?.vehiclePlate;

    dataToPost.product = availableServices?.selected?._id;
    dataToPost.case = _case?._id;
    dataToPost.provider = selectedBike; // // Unicamente para casos particulares

    let fileToPost = appendFile(dataToPost);
    if (!isLoading && fileToPost) {
      setIsloading(true);
      servicesService
        .createAVService(fileToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`AV creado con exito`, "success");
            history.push("/services");
            setIsloading(false);
          } else {
            setShowErrorAPI(true);
            notify(
              `${response?.data?.message || response?.message || "No pudimos validar el pago, por favor revisa los datos ingresados"}`,
              "error"
            );
            setIsloading(false);
          }
        })
        .catch((error) => {
          setShowErrorAPI(true);
          setIsloading(false);
        });
    }
  });

  const selectBikeProvider = (e) => {
    setSelectedBike(e?.target?.value);
  };

  const handleCancelService = (incidence) => {
    if (incidence) {
      membershipService
        .getCancelReason(resolveCancelReasonType(incidence))
        .then((response) => {
          if (response.status === 200) {
            setShowCancelService({
              cancelOptions: response?.data?.newCancellationReasons,
              show: !showCancelService.show,
              selected: incidence ? incidence : "",
            });
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });
    } else {
      setShowCancelService({
        cancelOptions: [],
        show: !showCancelService.show,
        selected: incidence ? incidence : "",
      });
    }
  };

  const openSMSTowModal = () => {
    setShowSMSTowModal((prevState) => {
      return {
        ...prevState,
        isOpen: !showSMSTowModal?.isOpen,
      };
    });
  };

  const handleEditService = (_case) => {
    if (_case) {
      servicesService
        .updateAV(_case?._id, { product: availableServices?.selected?._id })
        .then((response) => {
          if (response.status === 200) {
            notify(`Servicio Editado`, "success");
            history?.push("/services");
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });
    }
  };

  const registerPayment = () => {
    if (_case?.particularCustomer) {
      setValue3("estimatedTime", exists(_case?.estimatedTime));
      setValue3(
        "contact",
        _case?.particularCustomer?.phonePrefix +
        "-" +
        _case?.particularCustomer?.phoneNumber
      );
      setValue3("vehicleYear", _case?.particularCustomer?.vehicleYear);
      setValue3(
        "vehicleColor",
        exists(_case?.particularCustomer?.vehicleColor)
      );
      setValue3(
        "vehiclePlate",
        exists(_case?.particularCustomer?.vehiclePlate)
      );
      setValue3(
        "vehicleBrand",
        capitalize(_case?.particularCustomer?.vehicleBrand?.brand)
      );
      setValue3(
        "vehicleModel",
        capitalize(_case?.particularCustomer?.vehicleModel?.model)
      );
    } else {
      setValue3(
        "contact",
        _case?.membership?.customer?.phonePrefix +
        "-" +
        _case?.membership?.customer?.phoneNumber
      );

      setValue3("vehicleYear", _case?.membership?.vehicle?.year);
      setValue3("vehicleModel", capitalize(_case?.membership?.vehicle?.model));
      setValue3("vehicleBrand", capitalize(_case?.membership?.vehicle?.brand));
      setValue3("vehiclePlate", exists(_case?.membership?.vehicle?.plate));
      setValue3("vehicleColor", capitalize(_case?.membership?.vehicle?.color));
      setValue3("estimatedTime", exists(_case?.estimatedTime));
    }
    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      setValue3("price", availableServices?.selected?.price);
      setValue3("pvp", watch6("price"));
      setValue3("paymentMethods", 1);
    }

    if (isLocksmithService(availableServices?.selected)) {
      // Cerrajeria: el costo lo carga el operador cuando llega la factura
      setLocksmithPaymentDefaults(setValue3);
    } else {
      setValue3("isLocksmith", false);
      // Add 30% extra charge if the provider has a price multiplier
      const provider = selectableProviders.find((p) => p._id === selectedBike);
      const multiplier = 1 + provider?.priceMultiplier / 100;
      setValue3("price", (availableServices?.selected?.price * multiplier).toFixed(2));
    }
    setOpenPayModal(true);
  };

  const scheduleService = handleSubmit4(async (data) => {
    let fecha = moment(data?.date).format("YYYY-MM-DD");
    let date = new Date(fecha + "T" + data?.time);
    date = moment(date).format();

    if (!isLoading) {
      setIsloading(true);
      caseService
        .scheduleCase(
          { date: date, productId: availableServices?.selected?._id },
          _case?._id
        )
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Servicio agendado con exito`, "success");

            if (
              [
                afiliatedServices?.craneExtended,
                afiliatedServices?.crane,
                particularServices?.crane,
              ].includes(availableServices?.selected?.code)
            ) {
              history.push("/services");
              setIsloading(false);
            } else {
              openSMSModal();
              setShowSchedule({
                show: true,
                battery: false,
              });
              setIsloading(false);
            }
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const handleBatteryChange = () => {
    if (watch6("battery")) {
      setValue6(
        "price",
        filterOptionById(batteryOptions, watch6("battery")).price
      );
    } else {
      setValue6("price", "");
    }
  };
  const handleScheduleBattery = (serviceCode) => {
    if (
      [
        afiliatedServices?.BATT_SALE,
        particularServices?.BATT_SALE_PART,
      ].includes(availableServices?.selected?.code)
    ) {
      setShowSchedule({
        ...showSchedule,
        battery: true,
      });
      handleBatterySaleModal();
    } else {
      setShowSchedule({
        ...showSchedule,
        battery: false,
        show: true,
      });
    }
  };

  const getBattery = () => {
    const params = {
      brandId:
        _case?.vehicleData?.brand?._id ||
        _case?.particularCustomer?.vehicleBrand?._id ||
        clientSearch?.selected?.vehicle?.brandId,
      modelId:
        _case?.vehicleData?.model?._id ||
        _case?.particularCustomer?.vehicleModel?._id ||
        clientSearch?.selected?.vehicle?.modelId,
      year:
        _case?.vehicleData?.year ||
        _case?.particularCustomer?.vehicleYear ||
        clientSearch?.selected?.vehicle?.year,
    };

    batteryService
      .getAvailable(params)
      .then((response) => {
        if (response.status === 200) {
          let options = response?.data?.available.map((e) => {
            const isRecommended = response?.data?.recommendation.some(
              (r) => r._id === e._id
            );
            return {
              _id: e?._id,
              name: `${e?.enterprise} ${e?.name}  ${e?.price}$ ${isRecommended ? "(Recomendado)" : ""
                }`,
              price: e?.price,
            };
          });
          setBatteryOptions(options);
          setValue6("battery", response?.data?.recommendation[0]?._id);
          setValue6("price", response?.data?.recommendation[0]?.price);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch((error) => { });
  };

  const acceptBatterySale = handleSubmit6(async (data) => {
    handleBatterySaleModal();
    if (showSchedule.battery) {
      setShowSchedule({
        ...showSchedule,
        show: true,
      });
      return null;
    }
    openSMSModal();
  });

  const handleBatterySaleModal = () => {
    if (!batterySaleModal?.isOpen) {
      getBattery();
    }

    setBatterySaleModal((prevState) => {
      return {
        ...prevState,
        isOpen: !batterySaleModal?.isOpen,
      };
    });
  };

  const setBsRate = (e) => {
    const { name, value } = e?.target;

    // Replocate Accholder in referene only if the method is Zelle or Paypal
    let method = name?.replace("accHolder", "method");
    let reference = name?.replace("accHolder", "reference");

    const selectedMethod = filterOptionById(paymentMethods, watch3(method));
    if (
      [metodosDePago.ZELLE, metodosDePago.PAYPAL].includes(selectedMethod?.name)
    ) {
      setValue3(reference, watch3(name));
    }

    if (!dollarRate) {
      setbsDisabled(false);
    }
    if (name.includes("amount")) {
      setValue3(
        name.replace("amount", "amountBsS"),
        (value * dollarRate).toFixed(2)
      );
    }

    if (/^method\d+$/.test(name)) {
      const slotIndex = name.replace("method", "");
      setValue3(`skipApiValidationError${slotIndex}`, false);
    }
  };

  const unSelectService = () => {
    // Restaurar "Sin dirección destino" al quitar Cerrajeria
    if (availableServices?.selected?.code === afiliatedServices?.LOCKSMITH) {
      setValue2("withOutDestinyAddress", prevWithOutDestinyRef.current);
    }

    let services = availableServices?.available;
    setSelectedBike("");
    services.forEach((e) => {
      e.selected = false;
      setAvailableServices((prevState) => {
        return {
          ...prevState,
          selected: "",
          available: [...services],
        };
      });
    });
  };

  let loadPaymentForms = (params) => {
    let payments = [];
    // lOOP through every payment method
    for (let i = 0; i < parseInt(getValues3("paymentMethods")); i++) {
      let payment = {
        method: params[`method` + i.toString()],
        reference: params[`reference` + i.toString()],
        amount: params[`amount` + i.toString()],
        amountBsS: params[`amountBsS` + i.toString()],
      };
      if (
        [
          metodosDePago?.CASH_USD,
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
        ].includes(
          filterOptionById(paymentMethods, params[`method` + i.toString()])
            ?.name
        )
      ) {
        payment.cashReceiver = params[`cashReceiver` + i.toString()];
      }

      if (params[`accHolder` + i.toString()]) {
        payment.accHolder = params[`accHolder` + i.toString()];
      }
      payments.push(payment);
    }

    // "REmove unwanted params from JSON"
    let words = [
      "method",
      "reference",
      "accHolder",
      "amount",
      "amountBsS",
      "paymentMethod",
    ];
    for (const key in params) {
      for (var i = 0, ln = words.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }
    params.payments = payments;
    return params;
  };

  const startTowService = () => {
    if (_case?.membership && !reason) {
      notify("Ingresar campos para realizar la busqueda", "info");
      return null;
    }

    const data = buildCreateTowPayload(availableServices?.selected, {
      case: _case?._id,
      reason: reason,
    });

    if (!isLoading) {
      setIsloading(true);
      stagesService
        .createInitialTowStage(filterParams(data))
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            history.push("/services");
            notify(`Servicio creado en búsqueda de grúa`, "success");
            setIsloading(false);
          } else {
            notify(`${response.message}`, "error");
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods("operations")
      .then((response) => {
        if (response.status === 200) {
          setPaymentMethods(response?.data);
          setFilteredMethods(
            response?.data?.filter((d) => d?.name !== metodosDePago?.CASH_USD)
          );
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const preloadForm = (_case) => {
    if ([caseType?.AFFILIATED, caseType?.PRIMARY_CARE].includes(_case?.caseType)) {
      getMembershipById(resolveId(_case?.membership));
      preloadCaseAfiliatedForm(_case);
    } else {
      preloadCaseParticularForm(_case);
    }

    if (
      [caseType?.PRIMARY_CARE, caseType?.ALLY].includes(_case?.caseType) &&
      _case?.vehicleData
    ) {
      if (_case?.businessAlly?._id) {
        setValue2("businessAlly", _case.businessAlly._id);
      }
      setValue2("firstName", _case?.vehicleData?.firstName);
      setValue2("lastName", _case?.vehicleData?.lastName);
      setValue2("vehicleBrand", _case?.vehicleData?.brand?._id);
      setValue2("vehicleColor", _case?.vehicleData?.color);
      setValue2("vehiclePlate", _case?.vehicleData?.plate);
      setValue2("vehicleYear", _case?.vehicleData?.year);
      setValue2("phone", formatPhoneForInput(
        _case?.vehicleData?.phonePrefix,
        _case?.vehicleData?.phoneNumber
      ));
      handleModelOptsions(_case?.vehicleData?.brand?._id);
      setTimeout(() => {
        setValue2("vehicleModel", _case?.vehicleData?.model?._id);
      }, 1500);

    }
    setValue2("originState", _case?.originState?._id);
    getCities(
      _case?.originState?._id,
      referenceLocation?.ORIGIN,
      _case?.originCity?._id
    );
    setValue2("originAddress", _case?.originAddress);
    setValue2("originReferencePoint", _case?.originReferencePoint);
    setValue2("destinyReferencePoint", _case?.destinyReferencePoint);
    if (_case?.fault?.description === "REPORTADO POR BOTMAKER") {
      setValue2("customerFailureReason", "");
    } else {
      setValue2("customerFailureReason", _case?.fault?._id);
    }

    if (_case?.destinyState) {
      setValue2("destinyState", _case?.destinyState?._id);
      getCities(
        _case?.destinyState?._id,
        referenceLocation?.DESTINY,
        _case?.destinyCity?._id
      );
      setValue2("destinyAddress", _case?.destinyAddress);
    } else {
      setValue2("withOutDestinyAddress", true);
    }
    setValue2("usualRoute", _case?.usualRoute);

    setCase(_case);
    setCaseForm(_case);
    setValue2("caseKm", _case?.caseKm);

    setValue2("destinyLocationLink", _case?.destinyLocationLink);
    setValue2("originLocationLink", _case?.originLocationLink);

    if (_case?.thirdPartyService) {
      setValue2("thirdPartyService", _case?.thirdPartyService);
      setValue2(
        "thirdPartyParticularCustomerName",
        _case?.thirdPartyParticularCustomerName
      );
      setValue2(
        "thirdPartyParticularCustomerLastName",
        _case?.thirdPartyParticularCustomerLastName
      );
      setValue2("thirdPartyVehicleYear", _case?.thirdPartyVehicleYear);
      setValue2("thirdPartyVehicleColor", _case?.thirdPartyVehicleColor);
      setValue2("thirdPartyVehiclePlate", _case?.thirdPartyVehiclePlate);
      setValue2(
        "thirdPartyServicePhonePrefix",
        _case?.thirdPartyServicePhonePrefix
      );
      setValue2(
        "thirdPartyServicePhoneNumber",
        _case?.thirdPartyServicePhoneNumber
      );
      setValue2("thirdPartyVehicleBrand", _case?.thirdPartyVehicleBrand?._id);
      handleModelOptsions(_case?.thirdPartyVehicleBrand?._id);
      setTimeout(() => {
        setValue2("thirdPartyVehicleModel", _case?.thirdPartyVehicleModel?._id);
      }, 1500);
    }

    setTimeout(() => {
      if (!isMountedRef.current) return;
      if (originRef.current) {
        originRef.current.value = capitalize(_case?.originAddress);
      }

      if (_case?.destinyState && destinyRef.current) {
        destinyRef.current.value = capitalize(_case?.destinyAddress);
      }
    }, 2500);
  };

  const openMapModal = () => {
    if (
      !getValues2("originState") ||
      !getValues2("originCity") ||
      !originRef.current.value
    ) {
      notify("Ingrese datos de origen", "error");
      return null;
    }
    if (
      !getValues2("destinyState") ||
      !getValues2("destinyCity") ||
      !destinyRef.current.value
    ) {
      notify("Ingrese datos de destino", "error");
      return null;
    }
    setValue2("originAddress", originRef.current.value);
    setValue2("destinyAddress", destinyRef.current.value);
    setOrigin({
      lat: "",
      lng: "",
      address: originRef.current.value,
    });
    setDestiny({
      lat: "",
      lng: "",
      address: destinyRef.current.value,
    });
    setMapModalOpen(true);
  };

  const validateCases = (_case) => {
    if (
      _case?.fault?.description === "REPORTADO POR BOTMAKER" &&
      !watch2("customerFailureReason")
    ) {
      return false;
    }

    // Aqi ponet una condicion
    if (_case?.services?.length == 0) {
      return true;
    }
    return true;
  };

  const handleCloseModal = () => {
    setValue2("caseKm", route?.distance);
    setValue2("estimatedTime", route?.time);
    setMapModalOpen(false);
    setRoute({
      time: "",
      distance: "",
    });
  };

  const preloadCaseAfiliatedForm = (_case) => {
    setValue2(
      "contactPhone",
      formatPhoneForInput(_case?.contactNumberPrefix, _case?.contactNumber)
    );
    setValue2("customerFailureDescription", _case?.customerFailureDescription);
    setValue2("originLocationStatus", addressEnum?.OTHER);
    setValue2("isOriginBasement", false);
    setValue2("destinyLocationStatus", addressEnum?.OTHER);
  };

  const preloadCaseParticularForm = (_case) => {
    setValue2(
      "contactPhone",
      formatPhoneForInput(_case?.contactNumberPrefix, _case?.contactNumber)
    );
    setValue2("customerFailureDescription", _case?.customerFailureDescription);
    setValue2("originLocationStatus", addressEnum?.OTHER);
    setValue2("isOriginBasement", false);
    setValue2("destinyLocationStatus", addressEnum?.OTHER);
  };

  const getMembershipById = (membershipId) => {
    membershipService
      .getMembershipById(membershipId, "operations")
      .then((response) => {
        if (response.status === 200) {
          setClientSearch((prevState) => {
            return {
              ...prevState,
              selected: response?.data?.membership,
              isOpen: false,
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getCaseById = (caseId) => {
    caseService
      .getCaseById(caseId)
      .then((response) => {
        if (response.status === 200) {
          Promise.allSettled([
            getPaymentMethods(),
            getStates(),
            getFaults(),
            getAVs(),
            getGarageLocation(response?.data?.case),
          ]).then((r) => {
            setTimeout(() => {
              preloadForm(response?.data?.case);
            }, 1500);
          });

          // if (response?.data?.case?.services?.length === 0) {
          if (!response?.data?.case?.membership) {
            getServices({
              originCity: response?.data?.case?.originCity?._id,
            });
          } else {
            getAvailableProducts(response?.data?.case);
          }
          // }
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const forceRecalulateDistance = () => {
    setValue2("caseKm", "");
  };

  const getCities = async (e, reference, cityId) => {
    forceRecalulateDistance();
    if (reference === referenceLocation?.ORIGIN) {
      // Evita usar las ciudades del estado anterior mientras cargan las nuevas
      setOriginCitiesOptions([]);
      // Si el usuario cambia el estado, la ciudad anterior ya no le pertenece
      if (e?.target) {
        setValue2("originCity", "");
      }
    }
    statesService
      .getCities(e?.target?.value ? e?.target?.value : e)
      .then((response) => {
        if (response.status === 200) {
          if (reference === referenceLocation?.ORIGIN) {
            setOriginCitiesOptions(response?.data?.cities);
            if (cityId) {
              setValue2("originCity", cityId);
            }
          }
          if (reference === referenceLocation?.DESTINY) {
            setDestinyCitiesOptions(response?.data?.cities);
            if (cityId) {
              setValue2("destinyCity", cityId);
            }
          }
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
    return true;
  };

  const getStates = () => {
    statesService
      .getStates()
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch(() => { });
  };

  const getFaults = () => {
    let params = {
      isActive: true,
      limit: 1000,
    };
    faultsService
      .getFaults(params)
      .then((response) => {
        if (response.status === 200) {
          setFaultsOptions(response?.data?.newFaults);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => { });
  };

  const handleLocation = (location, reference) => {
    if (
      location &&
      ![addressEnum?.OWN, addressEnum?.OTHER]?.includes(location)
    ) {
      let [filteredOption] = addressOption.filter((a) => a?._id === location);
      setValue2(`${reference}State`, filteredOption?.stateId);
      statesService
        .getCities(filteredOption?.stateId)
        .then((response) => {
          if (response.status === 200) {
            if (reference === referenceLocation?.ORIGIN) {
              setOriginCitiesOptions(response?.data?.cities);
            }
            if (reference === referenceLocation?.DESTINY) {
              setDestinyCitiesOptions(response?.data?.cities);
            }
          } else {
            notify(`${response.message}` || "error", "error");
          }
        })
        .catch(() => { });

      setTimeout(() => {
        if (!isMountedRef.current) return;
        setValue2(`${reference}City`, filteredOption?.cityId);
        if (referenceLocation?.ORIGIN === reference && originRef.current) {
          originRef.current.value = capitalize(filteredOption?.address);
        }
        if (referenceLocation?.DESTINY === reference && destinyRef.current) {
          destinyRef.current.value = capitalize(filteredOption?.address);
        }
      }, 1200);
    }
  };

  const selectGarage = (e, reference) => {
    forceRecalulateDistance();
    const { value } = e?.target;
    // Preload GARAGE data
    if (value && ![addressEnum?.OWN, addressEnum?.OTHER]?.includes(value)) {
      handleLocation(value, reference);
    }
    // Own Value
    if (value === addressEnum?.OWN) {
      Promise.allSettled([
        getCities(clientSearch?.selected?.vehicle?.stateId, reference),
      ]).then((r) => {
        setTimeout(() => {
          if (!isMountedRef.current) return;
          setValue2(
            `${reference}State`,
            clientSearch?.selected?.vehicle?.stateId
          );
          setValue2(
            `${reference}City`,
            clientSearch?.selected?.vehicle?.cityId
          );

          if (referenceLocation?.ORIGIN === reference && originRef.current) {
            originRef.current.value = capitalize(
              clientSearch?.selected?.vehicle?.address
            );
          }
          if (referenceLocation?.DESTINY === reference && destinyRef.current) {
            destinyRef.current.value = capitalize(
              clientSearch?.selected?.vehicle?.address
            );
          }
        }, 1500);
      });
    }
  };
  const getRecommendedProviders = () => {
    const requestId = ++recommendedProvidersRequestRef.current;
    const params = buildLocksmithProvidersParams({
      state: getValues2("originState"),
      city: getValues2("originCity"),
      cities: originCitiesOptions,
    });
    if (!params) {
      setRecommendedProvidersOptions([]);
      setSelectedBike("");
      return;
    }
    providersService
      .getProviders(filterParams(params))
      .then((response) => {
        // Descarta respuestas de una ubicacion que ya cambio
        if (requestId !== recommendedProvidersRequestRef.current) return;
        if (response.status === 200) {
          const providers = response?.data?.providers || [];
          setRecommendedProvidersOptions(providers);
          // Suelta el proveedor elegido si no atiende la nueva ubicacion
          setSelectedBike((prev) =>
            providers.some((p) => p?._id === prev) ? prev : ""
          );
        } else {
          setRecommendedProvidersOptions([]);
          setSelectedBike("");
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const getAVs = () => {
    providersService
      .getAVs()
      .then((response) => {
        if (response.status === 200) {
          setProvidersOptions(response?.data?.providers);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const validateCashBackImages = () => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let canPost = true;

    setErrorsDropzone((prevState) => {
      return {
        ...prevState,
        error1: false,
        error2: false,
        error3: false,
      };
    });

    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      const requiredMetods = paymentMethods?.filter((method) =>
        [
          metodosDePago?.CASH_BS,
          metodosDePago?.CASH_EUR,
          metodosDePago?.CASH_USD,
          metodosDePago?.PUNTO_DE_VENTA,
        ]?.includes(method?.name)
      );
      const method = filterOptionById(
        requiredMetods,
        watch3("returnedMethod" + i)
      );

      if (method && !watch3(`returnedReference${i}`)) {
        setError3(`returnedReference${i}`, {
          type: "custom",
          message: "Obligatorio",
        });
        canPost = false;
      }

      if (!cashBackImage[`image${i}`] && method) {
        notify(
          `Adjunte todos los comprobantes de pago de ${method?.name}`,
          "error"
        );
        canPost = false;
        setErrorsDropzone((prevState) => {
          return {
            ...prevState,
            [`error${i}`]: true,
          };
        });
      }
    }
    return canPost;
  };

  const calculateCashBack = () => {
    if (parseFloat(watch3("paid")) > parseFloat(watch3("amount0"))) {
      setValue3(
        "paidBsS",
        (parseFloat(watch3("paid")) * dollarRate)?.toFixed(2)
      );

      if (!watch3("cashbackMethodsQuantity")) {
        setValue3("cashbackMethodsQuantity", 1);
        let amountReturned =
          parseFloat(watch3(`amount0`)) - parseFloat(watch3("paid"));
        if (parseFloat(watch3(`amount1IGTF`))) {
          amountReturned = amountReturned + parseFloat(watch3(`amount1IGTF`));
        }
        amountReturned = amountReturned?.toFixed(2);
        setValue3("amountReturned", Math.abs(amountReturned));
        setValue3(
          "amountReturnedBsS",
          (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
        );
        setValue3(`returnedAmount1`, Math.abs(amountReturned));
        setValue3(
          `returnedAmountBsS1`,
          (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
        );
      }
    }
  };

  const validateCashBackTotal = () => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch3(`amountReturned`));
    let total = 0;
    for (let i = 1; i <= cashbackMethodsQuantity; i++) {
      total = total + parseFloat(watch3(`returnedAmount${i}`));
    }

    if (total !== amountReturned) {
      notify(
        "El la suma de los montos debe ser igual al monto a entregar",
        "error"
      );
      return false;
    }
    if (!watch3("returnedMethod1")) {
      // setError3(`returnedMethod1`, { type: 'custom', message: 'Obligatorio' });
      return false;
    } else {
      return true;
    }
  };

  const handleCashbackMethodsQuantity = () => {
    for (let i = 1; i <= 3; i++) {
      setValue3(`returnedMethod${i}`, "");
      setValue3(`returnedAmount${i}`, "");
      setValue3(`returnedAmountBsS${i}`, "");
      setCashBackImage((prevState) => {
        return {
          ...prevState,
          [`image${i}`]: "",
        };
      });
    }

    if (watch3("cashbackMethodsQuantity") === "1") {
      setValue3(`returnedAmount1`, watch3("amountReturned"));
      setValue3(
        `returnedAmountBsS1`,
        (parseFloat(watch3("amountReturned")) * dollarRate)?.toFixed(2)
      );
    }
  };

  const handleCashbackBs = (index) => {
    let cashbackMethodsQuantity = parseFloat(watch3("cashbackMethodsQuantity"));
    let amountReturned = parseFloat(watch3(`amountReturned`));

    setValue3(
      `returnedAmountBsS${index}`,
      (parseFloat(watch3(`returnedAmount${index}`)) * dollarRate)?.toFixed(2)
    );

    // Automatically set the amount for the last method
    if (index === cashbackMethodsQuantity - 1) {
      let paid = 0;
      for (let i = 1; i < cashbackMethodsQuantity; i++) {
        paid = paid + parseFloat(watch3(`returnedAmount${i}`));
      }

      if (amountReturned - paid <= 0) {
        notify(
          "El la suma de los montos no puede superar el vuelto a entregar",
          "error"
        );
        for (let j = 1; j <= cashbackMethodsQuantity; j++) {
          setValue3(`returnedAmount${j}`, 0);
          setValue3(`returnedAmountBsS${j}`, 0);
        }
        return null;
      }

      setValue3(
        `returnedAmount${cashbackMethodsQuantity}`,
        (amountReturned - paid)?.toFixed(2)
      );
      setValue3(
        `returnedAmountBsS${cashbackMethodsQuantity}`,
        (
          parseFloat(watch3(`returnedAmount${cashbackMethodsQuantity}`)) *
          dollarRate
        )?.toFixed(2)
      );
    }
  };

  const handleDrop = (event, index) => {
    let file = "";
    // File added on drop
    if (event?.dataTransfer?.files) {
      file = Array?.from(event?.dataTransfer?.files)[0];
    }

    let maxWeight = 5; //Peso en MB

    // File added on Click
    if (event?.target?.files?.length > 0) {
      file = event?.target?.files[0];
    }

    if (
      !["image/png", "image/jpg", "image/jpeg", "application/pdf"].includes(
        file.type
      )
    ) {
      notify("Agregar un formato valido de imagen", "error");
      return null;
    }
    if (file.size * 0.000001 > maxWeight) {
      notify(`La imagen no debe superar los ${maxWeight} MB`, "error");
    }
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: file,
      };
    });
  };

  const removeFile = (index) => {
    setCashBackImage((prevState) => {
      return {
        ...prevState,
        [`image${index}`]: "",
      };
    });
  };

  const getGarageLocation = (caso) => {
    garageService
      .getGarageAddress()
      .then((response) => {
        if (response.status === 200) {
          setAddressOption([
            caso?.caseType === caseType?.AFFILIATED && {
              name: addressEnum?.OWN,
              _id: addressEnum?.OWN,
            },
            ...response?.data?.addresses,
            { name: addressEnum?.OTHER, _id: addressEnum?.OTHER },
          ]);
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const isLocksmithSelected =
    availableServices?.selected?.code === afiliatedServices?.LOCKSMITH;
  const originStateId = watch2("originState");
  const originCityId = watch2("originCity");

  // Proveedores Recomendados de Cerrajeria filtrados por estado y ciudad de origen
  useEffect(() => {
    if (!isLocksmithSelected) return;
    getRecommendedProviders();
  }, [isLocksmithSelected, originStateId, originCityId, originCitiesOptions]);

  useEffect(() => {
    isMountedRef.current = true;
    getVehicleBrands();
    getInternalTowServices();
    getCaseById(caseId);
    getCashReceivers();
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (chatRacePreloadDone.current) return;
    if (_case?.chatRace !== true || _case?.status !== enumStatus.INITIATED) return;
    if (!availableServices?.available?.length) return;

    chatRacePreloadDone.current = true;

    const scheduledProductId =
      _case?.scheduledProduct?._id || _case?.scheduledProduct;
    const matchedProduct = availableServices.available.find(
      (s) => {
        return s._id === scheduledProductId;
      }
    );
    if (!matchedProduct) {
      notify(
        "No se pudo precargar el servicio agendado del caso",
        "error"
      );
      return;
    }

    selectService(matchedProduct);

    if (_case?.scheduleDate) {
      const sd = moment(_case.scheduleDate);
      if (sd.isValid()) {
        setValue4("date", sd.toDate());
        setValue4("time", sd.format("HH:mm"));
      }
    }
  }, [_case, availableServices.available]);

  const validateEditCase = () => {
    if (_case?.status === enumStatus.INITIATED) {
      return false;
    } else return true;
  };

  validateEditCase();

  const getInternalTowServices = () => {
    let params = {
      type: "all",
    };

    providersService
      .getInternalTowServices(params)
      .then((response) => {
        if (response.status === 200) {
          setShowCraneCounterModal((prevState) => {
            return {
              ...prevState,
              data: response?.data,
            };
          });
        } else {
          notify(`${response.message}`, "error");
        }
      })
      .catch(() => { });
  };

  const openDocumentModal = (src, service) => {
    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        show: !showCraneCounterModal?.show,
        src: !showCraneCounterModal?.src ? src : "",
        service: service,
      };
    });
  };

  const zoomDocumentModal = (zoom) => {
    setShowCraneCounterModal((prevState) => {
      return {
        ...prevState,
        zoom: zoom,
      };
    });
  };

  const handleReason = (e) => {
    setReason(e?.target?.value);
  };

  const { handleAddIva } = useIvaCalculation({
    watch: watch3,
    setValue: setValue3,
  });

  return (
    <>
      <CraneCounter
        showCraneCounterModal={showCraneCounterModal}
        openDocumentModal={openDocumentModal}
        zoomDocumentModal={zoomDocumentModal}
        craneCounter={craneCounter}
      />
      {availableServices?.selected?.code === afiliatedServices?.LOCKSMITH ? (
        <MessageLocksmithModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={caseInfo}
          action={registerPayment}
          service={availableServices?.selected}
          _case={_case}
        />
      ) : (
        <MessageAVModal
          showSMSModal={showSMSModal}
          handleClose={openSMSModal}
          caseInfo={caseInfo}
          _case={_case}
          action={
            [
              afiliatedServices?.BATT_SALE,
              particularServices?.BATT_SALE_PART,
            ].includes(availableServices?.selected?.code) && !watch6("battery")
              ? ""
              : registerPayment
          }
          service={availableServices?.selected}
        />
      )}
      <BatterySaleModal
        showSMSModal={batterySaleModal}
        handleClose={handleBatterySaleModal}
        register={register6}
        errors={errors6}
        onChange={{ handleBatteryChange: handleBatteryChange }}
        options={{
          batteryOptions: batteryOptions,
        }}
        action={acceptBatterySale}
      />
      <MessageTowModal
        showSMSModal={showSMSTowModal}
        handleClose={openSMSTowModal}
        caseInfo={caseInfo}
        action={startTowService}
      />

      <ScheduleServicesModal
        show={showSchedule.show}
        handleClose={() =>
          setShowSchedule({
            ...showSchedule,
            show: false,
            battery: false,
          })
        }
        register={register4}
        control={control4}
        errors={errors4}
        action={scheduleService}
        t={t}
      />

      <CreateAVModal
        show={openPayModal}
        register={register3}
        openPayModal={openPayModal}
        handleClose={() => setOpenPayModal()}
        createAVService={createAVService}
        errors={errors3}
        options={{
          paymentMethods: paymentMethods,
          PaymentStatusOptions: PaymentStatusOptions,
          authorizedByOptions: authorizedByOptions,
          filteredMethods: filteredMethods,
          cashReceiverOptions: cashReceiverOptions,
        }}
        onChange={{
          changePaymentStatus: changePaymentStatus,
          restorePaymentMethods: restorePaymentMethods,
          setBsRate: setBsRate,
          validateMaxPaymentMethods: validateMaxPaymentMethods,
          handleCashbackMethodsQuantity: handleCashbackMethodsQuantity,
          handleCashbackBs: handleCashbackBs,
          setIsloading: setIsloading,
          handleAddIva: handleAddIva,
        }}
        battery={[
          afiliatedServices?.BATT_SALE,
          particularServices?.BATT_SALE_PART,
        ].includes(availableServices?.selected?.code)}
        watch={watch3}
        sertValue={setValue3}
        setFileUploaded={setFileUploaded}
        fileUploaded={fileUploaded}
        bsDisabled={bsDisabled}
        handleDrop={handleDrop}
        cashBackImage={cashBackImage}
        removeFile={removeFile}
        errorsDropzone={errorsDropzone}
        showErrorAPI={showErrorAPI}
      />

      <Header />
      <div className="container">
        {_case && (
          <div className="card incidence-card">
            <div className="title-center-component">
              <h4>Caso nro. {_case?.caseId} </h4>
              <p style={{ color: "#6B6B6B", margin: "0px" }}>
                Fecha de creación:{" "}
                <b> {_case?.createdAt ? moment(_case?.createdAt)?.format("DD/MM/YYYY") : ""}</b>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Hora de creación:&nbsp;
                <b>{_case?.createdAt ? moment(_case?.createdAt)?.format("LTS") : ""}</b>
              </p>
            </div>
            <br />
            {[caseType?.ALLY].includes(_case?.caseType) && (
              <>
                <div className="light-gray-line"></div>
                <AllyDetail membership={_case?.businessAlly} />
              </>
            )}
            {[caseType?.AFFILIATED, caseType?.PARTICULAR].includes(
              _case?.caseType
            ) && (
                <>
                  <div className="light-gray-line"></div>
                  <ClientDetail membership={_case?.membership} _case={_case} />
                </>
              )}
            {_caseForm && (
              <IncidenceDetailForm
                register={register2}
                editCase={
                  [caseType?.AFFILIATED, caseType?.PRIMARY_CARE].includes(_case?.caseType)
                    ? editAffiliatedCase
                    : editParticularCase
                }
                errors={errors2}
                setValue={setValue2}
                getValues={getValues2}
                watch={watch2}
                suggestion={{
                  originRef: originRef,
                  destinyRef: destinyRef,
                }}
                onChange={{
                  getCities: getCities,
                  selectGarage: selectGarage,
                  clearThirdPartyData: clearThirdPartyData,
                  forceRecalulateDistance: forceRecalulateDistance,
                  handleModelOptsions: handleModelOptsions,
                  updateLocationStatus: updateLocationStatus,
                }}
                options={{
                  statesOptions: statesOptions,
                  originCitiesOptions: originCitiesOptions,
                  destinycitiesOptions: destinycitiesOptions,
                  faultsOptions: faultsOptions,
                  addressOption: addressOption,
                  brandOptions: brandOptions,
                  modelOptions: modelOptions,
                  vehicleBrandOptions: brandOptions,
                  vehicleModelOptions: modelOptions,
                }}
                openMapModal={openMapModal}
                _case={_case}
                disabled={validateEditCase()}
                clientSearch={clientSearch}
                clientType={
                  _case?.caseType === caseType?.ALLY || _case?.papMembership
                    ? clientTypes.ALLY
                    : ""
                }
                control={control2}
                lockWithOutDestinyAddress={
                  availableServices?.selected?.code ===
                  afiliatedServices?.LOCKSMITH
                }
              />
            )}
            <MapModal
              show={mapModalOpen}
              handleClose={handleCloseModal}
              origin={origin}
              setOrigin={setOrigin}
              destiny={destiny}
              setDestiny={setDestiny}
              route={route}
              setRoute={setRoute}
            />

            {validateCases(_case) && (
              <AvailableServices
                availableServices={availableServices}
                selectService={selectService}
                _case={_case}
              />
            )}

            <CancelServiceModal
              showCancelService={showCancelService}
              handleClose={() => handleCancelService()}
              refresh={refreshAfterCancel}
            />

            {availableServices?.selected && (
              <SelectedServices
                providersOptions={providersOptions}
                recommendedProvidersOptions={recommendedProvidersOptions}
                availableServices={availableServices}
                unSelectService={unSelectService}
                value={selectedBike}
                onChange={selectBikeProvider}
                openSMSModal={openSMSModal}
                openSMSTowModal={openSMSTowModal}
                _case={_case}
                handleReason={handleReason}
                reason={reason}
              />
            )}

            {availableServices?.selected && (
              <HandleCaseButtons
                setShowSchedule={setShowSchedule}
                handleScheduleBattery={handleScheduleBattery}
                startTowService={startTowService}
                selectedBike={selectedBike}
                service={availableServices?.selected}
                _case={_case}
                handleCancelService={handleCancelService}
                registerPayment={registerPayment}
                openModals={{
                  openSMSTowModal: openSMSTowModal,
                  openSMSModal: openSMSModal,
                  handleEditService: handleEditService,
                  handleBatterySaleModal: handleBatterySaleModal,
                }}
                bikerData={getOption(selectedBike, selectableProviders)}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export const CaseDetail = (props) => {
  const { title, data } = props;

  return (
    <div className="incidence-table-section-container">
      <div className="filter-button-container"></div>
      <div className="buttons-container">
        <h6>{title}</h6>
      </div>
      <div className="row">
        <div className="col-12 col-lg-6 col-xl-4">
          <p>
            <b>Avería: </b>
            {exists(data?.fault?.description)}
            <br />
            <b>Caso Nro: </b> {exists(data?.caseId)}
            <br />
            <b>Operador: </b>
            {exists(data?.user?.firstName) +
              "   " +
              exists(data?.user?.lastName)}
          </p>
        </div>
      </div>
    </div>
  );
};
